import packageInfo from '../../../../package.json';

const VersionBadge = ({onClick}) => (
    <div
        className='fixed bottom-0 right-0 z-[1100] cursor-pointer rounded-tl-md bg-color-primary p-1 text-14 text-white opacity-80 backdrop-blur-sm'
        onClick={onClick}
    >
        {packageInfo.version}
    </div>
);

export default VersionBadge;
